import { render, staticRenderFns } from "./DocPropsTableRow.vue?vue&type=template&id=3d2045d3"
import script from "./DocPropsTableRow.vue?vue&type=script&lang=js"
export * from "./DocPropsTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports